export default "__VITE_ASSET__CzoNSRnB__"